import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Authenticated = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    
    if (!token) {
      navigate('/', { 
        replace: true,
        state: { from: location.pathname } 
      });
    } 
  }, [navigate, location]);

  return <>{children}</>;
};

export default Authenticated;